module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/dt-seattle-600.9be6427aed2daad1.png"+" 600w",
        images: [{path: "https://static.sniffspot.com/packs/img/dt-seattle-600.9be6427aed2daad1.png",width: 600,height: 450}],
        src: "https://static.sniffspot.com/packs/img/dt-seattle-600.9be6427aed2daad1.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/dt-seattle-600.9be6427aed2daad1.png"},
        
        width: 600,
        height: 450
      }